fragment StatusCodeWithErrorMessageResponseFragment on ResponseStatusWithErrorMessage {
  response {
    StatusCode
    ErrorMessages
  }
}

fragment InvoiceFragment on Invoice {
  Id
  CompanyId
  InvoiceCode
  Number
  CreatedDate
  LocalCreatedDate
  DueDate
  LocalDueDate
  OriginalAmount
  AmountOwing
  State
  SettledDate
  LocalSettledDate
  Type
  GlCode
  Customer {
    ...CustomerFragment
  }
  AgedTrialBalanceFromCreate {
    ...AgedTrialBalanceFromCreateFragment
  }
  AgedTrialBalanceFromDue {
    ...AgedTrialBalanceFromDueFragment
  }
  Uri
  CustomFields {
    ...CustomFieldFragment
  }
  Attachments {
    ...AttachmentFragment
  }
  PromiseToPayDate
  LocalPromiseToPayDate
  Company {
    IsCalendarView
    IsDueDateView
  }
}

fragment EnhancedInvoiceFragment on Invoice {
  Id
  CompanyId
  InvoiceCode
  Number
  CreatedDate
  LocalCreatedDate
  DueDate
  LocalDueDate
  OriginalAmount
  AmountOwing
  State
  SettledDate
  LocalSettledDate
  Type
  GlCode
  CustomerId @include(if: $IsInvoicePanelView)
  Customer @skip(if: $IsInvoicePanelView) {
    ...CustomerFragment
  }
  AgedTrialBalanceFromCreate {
    ...AgedTrialBalanceFromCreateFragment
  }
  AgedTrialBalanceFromDue {
    ...AgedTrialBalanceFromDueFragment
  }
  Uri
  CustomFields {
    ...CustomFieldFragment
  }
  Attachments {
    ...AttachmentFragment
  }
  PromiseToPayDate
  LocalPromiseToPayDate
  Company {
    IsCalendarView
    IsDueDateView
  }
}

fragment CreditFragment on Credit {
    Id
    CreditCode
    Number
    CreatedDate
    LocalCreatedDate
    AvailableDate
    LocalAvailableDate
    OriginalAmount
    AmountAvailable
    State
    ClosedDate
    Customer {
        ...CustomerFragment
    }
    AgedTrialBalanceFromCreate {
        ...AgedTrialBalanceFromCreateFragment
    }
    AgedTrialBalanceFromDue {
        ...AgedTrialBalanceFromDueFragment
    }
    Uri
    CustomFields {
        ...CustomFieldFragment
    }
    Attachments {
        ...AttachmentFragment
    }
    Type
    CreatedType
    Percentage
    Description
    IsRecurring
    MultipleCustomer
    Company {
        IsCalendarView
        IsDueDateView
    }
}

fragment AgedTrialBalanceFromCreateFragment on AgedTrialBalanceFromCreate {
  Current
  Period1
  Period2
  Period3Plus
}

fragment AgedTrialBalanceFromDueFragment on AgedTrialBalanceFromDue {
  Current
  Period1
  Period2
  Period3Plus
  NotDue
}

fragment CustomerFragment on Customer {
  Id
  CompanyId
  CustomerCode @skip(if: $IsCloudImportType)
  CompanyName
  TaxNumber
  SecondaryTaxNumber
  IsVip
  IsVipExpiryDate
  NewInvoiceSendMode
  DisplayName
  Contacts {
    ...ContactFragment
  }
  AgedTrialBalance {
    TotalOwing
    TotalOverdue
    AgedTrialBalanceFromCreate {
      ...AgedTrialBalanceFromCreateFragment
    }
    AgedTrialBalanceFromDue {
      ...AgedTrialBalanceFromDueFragment
    }
  }
  Uri
  CustomFields {
    ...CustomFieldFragment
  }
  Attachments {
    ...AttachmentFragment
  }
  PayerState
  CreditLimit
  TotalCreditUsed
  WorkflowName
  Company {
    IsCalendarView
    IsDueDateView
  }
  IsOrganisationView
  ParentCustomerCode
}

fragment CustomFieldFragment on CustomField {
  Name
  Value
}

fragment DeliveryDetailFragment on DeliveryDetails {
  Type
  Comment
  State
}

fragment ContactFragment on Contact {
    Id
    FirstName
    LastName
    AddressLine1
    AddressLine2
    City
    State
    Postcode
    Country
    CountryCode
    Email
    MobileNumber
    Landline
}

fragment DeliveryDetailsFragment on DeliveryDetails {
  Type
  Comment
  State
  Reason
  DateSent
}

# fragment TaskFragment on Task {
#     Id
#     CompanyId
#     Type
#     Automation
#     ActionDate
#     State
#     Customer {
#         ...CustomerFragment
#     }
#     Invoice {
#         ...InvoiceFragment
#     }
#     Workflow {
#         WorkflowId
#         StateName
#     }
#     CreatedDateTime
# }

fragment CompanyContactFragment on CompanyContact {
  Name
  Email
  PhoneNumber
  Type
}

fragment TicketOptionLabelsFragment on TicketOptionLabels {
  DateTimeLabel
  PaymentLabel
}

fragment CompanyFragment on Company {
  CompanyId
  Name
  Email
  LogoPath
  CreatedDateTime
  UpdateDateTime
  AddressLine1
  AddressLine2
  Suburb
  State
  Postcode
  PhoneNumber
  ABN
  Timezone
  Industry
  PrimaryColorTheme
  SecondaryColorTheme
  CompanyContacts {
    ...CompanyContactFragment
  }
}

fragment CompanyCustomFieldConfigureFragment on CompanyCustomFieldConfigure {
  Id
  Type
  Number
  FieldName
  DataType
  Required
  MinValue
  MaxValue
  DefaultValue
  FilterType
  DisplayInNotification
}

fragment TicketOptionFragment on TicketOption {
  Id
  Reason
  CaptureMessage
  Type
  PrimaryText
  SupplementaryText
  LinkTicketOption
  Hidden
  NonBlocking
  TicketOptionLabels {
    ...TicketOptionLabelsFragment
  }
}

fragment PaymentOptionsFragment on PaymentOptions {
  CardPaymentOption {
    Name
    SelectedCreditCards
    SelfManagedPaymentOption {
      Description
    }
    CreditCardPaymentOption {
      CreditCardPaymentUrl
    }
    EziDebitPaymentOption {
      PaymentUrl @skip(if: $IsPublic)
      EDDRUrlExist
      EDDRUrl @skip(if: $IsPublic)
      MaskedDigitalKey @skip(if: $IsPublic)
      MaskedPublicKey @skip(if: $IsPublic)
    }
    IntegraPayPaymentOption @skip(if: $IsPublic) {
      Username
    }
    AdvamPaymentOption @skip(if: $IsPublic) {
      AccountNumber
      Username
    }
    ClientReference
  }
  OverseasCardPaymentOption {
    Name
    SelfManagedPaymentOption {
      Description
    }
    CreditCardPaymentOption {
      CreditCardPaymentUrl
    }
  }
  WesternUnionPaymentOption {
    IsEnabled
    ClientId @skip(if: $IsPublic)
    ServiceId @skip(if: $IsPublic)
    ClientReference
    ConveraCustomFields
  }
  CorpayPaymentOption {
    IsEnabled
    Status
  }
  XeroPaymentOption {
    IsEnabled
    IsConnected
  }
  TransferMateEduPaymentOption {
    IsEnabled
    BankAccountId
    EduInstituteName
    PaymentPurpose
    BeneIBAN
    BeneAccountName
    BeneAccountNumber
  }
  MailingChequePaymentOption {
    IsEnabled
  }
  BankPaymentOption {
    IsEnabled
    AccountName
    AccountBSBNumber
    AccountNumber
    SwiftCode
    IBAN
    ReferenceNumber
  }
  EnablePartialPayment
  BpayPaymentOption {
    IsEnabled
    BillerCode
    BPayReference
  }
  EnableConveraPanel
  InvoicePartialPaymentOption {
      IsEnabled
      CustomFieldName
  }
}

fragment AttachmentFragment on Attachment {
  FileId
  IsPublic
  Title
  IsExternal
  ExternalUrl
}

fragment ConversationLineCommentFragment on ConversationLine {
  Content
  CreatedDateTime
  User {
    GivenName
    FamilyName
  }
  ExternalEmailAddress
}

fragment LanguagePackageFragment on LanguagePackage {
  Language
  Suburb
  State
  Postcode
  CompanyRegistrationNumber
  BankBSB
  BankAccountNumber
  DateFormat
  CurrentDateFormat
}

fragment RemittanceAdviceFragment on RemittanceAdvice {
  Id
  Status
  ReceivedDate
  Amount
  MultipleCustomer
  Uri
}

fragment RemittanceAdviceInvoicesFragment on RemittanceAdviceInvoice {
  Invoice {
    ...InvoiceFragment
  }
  Customer {
    ...CustomerFragment
  }
  Number
  Amount
  RemittanceAdviceId
  AllowOverpayment
}

fragment RemittanceAdviceSalesOrdersFragment on RemittanceAdviceSalesOrder {
  SalesOrder {
    ...InvoiceFragment
  }
  Customer {
    ...CustomerFragment
  }
  Number
  Amount
  RemittanceAdviceId
}

fragment RemittanceAdviceCreditsFragment on RemittanceAdviceCredit {
  Credit {
    ...CreditFragment
  }
  Invoice {
    Id
  }
  Customer {
    Id
  }
  Number
  Amount
  AllowOverclaim
}

fragment RemittanceAdviceRebatesFragment on RemittanceAdviceRebate {
  Rebate {
    ...CreditFragment
  }
  AmountToAllocate
  MultipleCustomer
}

fragment PaymentFragment on Payment {
  Id
  Result
  ResultDescription
  PaidDate
  LocalPaidDate
  PaidAmount
  AllocatedAmount
  MultipleCustomers
  Customer {
    ...CustomerFragment
  }
  Uri
  ConversationLine {
    ...ConversationLineCommentFragment
  }
  Attachments {
    ...AttachmentFragment
  }
  Source
  PaymentReference
  BankReceiptNumber
  SettlementDate
  LocalSettlementDate
  PaymentMethod
  TransactionFeeBuyer
  TransactionFeeSeller
  VerificationState
  InvoicesAllocated
  SalesOrdersAllocated
  # Allocations {
  #     AmountAllocated
  #     InvoiceResource {
  #         Id
  #         Number
  #         InvoiceCode
  #     }
  #     ToResource {
  #         Id
  #     }
  # }
  BankInstitution
}

fragment PaymentPlanFragment on PaymentPlan {
    Id
    State
    InvoiceIds
    TotalAmount
    AmountRemaining
    LocalRequestedDateTime
    LocalApprovedDateTime
    Number
    LocalClosedDateTime
    TotalSchedules
    Frequency
    PaymentPlanSchedules {
        Id
        PaymentPlanId
        Number
        State
        TotalAmount
        AmountRemaining
        LocalDueDateTime
        DueDateTime
        LocalClosedDateTime
    }
    ClosedComment
}

fragment EnhancedPaymentFragment on Payment {
  Id
  Result
  ResultDescription
  PaidDate
  LocalPaidDate
  PaidAmount
  AllocatedAmount
  MultipleCustomers
  CustomerId @include(if: $IsPaymentPanelView)
  Customer @skip(if: $IsPaymentPanelView) {
    ...CustomerFragment
  }
  Uri
  ConversationLine {
    ...ConversationLineCommentFragment
  }
  Attachments {
    ...AttachmentFragment
  }
  Source
  PaymentReference
  BankReceiptNumber
  SettlementDate
  LocalSettlementDate
  PaymentMethod
  TransactionFeeBuyer
  TransactionFeeSeller
  VerificationState
  InvoicesAllocated
  SalesOrdersAllocated
  BankInstitution
}

fragment CompanyPaymentPlanFragment on CompanyPaymentPlan {
  IsEnabled
  TermsAndConditions
  TotalSchedules
  Frequency
}

fragment CompanyNotificationCustomizationFragment on CompanyNotificationCustomization {
  BrandingLocation
  OpeningWording
  IncludeLinkInLetterBlock
  InformUsInstruction
  InformUsTextLabel
  CreditUsageWording
  CardPaymentCustomization {
    Heading
    Description
  }
  MailingChequePaymentCustomization {
    Heading
    Description
  }
  BankPaymentCustomization {
    Heading
    Description
  }
}

fragment CompanyPublicViewFragment on CompanyPublicView {
  CompanyId
  Name
  Email
  LogoPath
  AddressLine1
  AddressLine2
  Suburb
  State
  Postcode
  Timezone
  PhoneNumber
  PrimaryColorTheme
  SecondaryColorTheme
  PaymentOptions {
    ...PaymentOptionsFragment
  }
  CustomFieldsConfigure {
    ...CompanyCustomFieldConfigureFragment
  }
  LanguagePackage {
    ...LanguagePackageFragment
  }
  CompanyPaymentPlan {
    ...CompanyPaymentPlanFragment
  }
  NotificationCustomization {
    ...CompanyNotificationCustomizationFragment
  }
}

fragment StudentPortalSidebarItemFragment on StudentPortalSidebarItem {
    Route
    Name
    Visible
    Description
    Parent
}

fragment ResourceFragment on Resource {
  Uri
  #Communication @include(if: $FetchResource) {
  #   ...CommunicationFragment
  #}
  Credit @include(if: $FetchResource) {
    ...CreditFragment
  }
  Rebate @include(if: $FetchResource) {
    ...CreditFragment
  }
  Customer @include(if: $FetchResource) {
    ...CustomerFragment
  }
  Invoice @include(if: $FetchResource) {
    ...InvoiceFragment
  }
  SalesOrder @include(if: $FetchResource) {
    ...InvoiceFragment
  }
  Payment @include(if: $FetchResource) {
    ...PaymentFragment
  }
  PaymentPlan @include(if: $FetchResource) {
   ...PaymentPlanFragment
  }
  #PaymentPlanSchedule @include(if: $FetchResource) {
  #  ...PaymentPlanScheduleFragment
  #}
  RemittanceAdvice @include(if: $FetchResource) {
    ...RemittanceAdviceFragment
    Customer {
        ...CustomerFragment
    }
  }
  #Task @include(if: $FetchResource) {
  #  ...TaskFragment
  #}
  #Ticket @include(if: $FetchResource) {
  #  ...TicketFragment
  #}
  WorkflowDefinition @include(if: $FetchResource) {
    Name
  }
}
 